import { FlexContainer, Spinner, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchGetReferralLinks } from 'Containers/Referral/hooks';
import { friendsRewards } from './utils';
import * as Styled from './styles';

const MAX_PROFITS = 10;
export const WinProbabilities = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { data, isLoading } = useFetchGetReferralLinks();

  return (
    <FlexContainer direction="column" fullWidth gap="dimension_16">
      <Text type="paragraphs" color="grey" size="XS_L_M" align="center">
        {t('Probabilities.title')}
      </Text>
      <Styled.TrackingProgress direction="column" fullWidth gap="dimension_08">
        {isLoading && !data ? (
          <FlexContainer justify="center" align="center">
            <Spinner size="M" align="center" justify="center" />
          </FlexContainer>
        ) : (
          <>
            <FlexContainer justify="space-between">
              {friendsRewards(data?.referredAmount || 0, MAX_PROFITS).map(reward => (
                <FlexContainer
                  key={reward.title}
                  direction="column"
                  align="center"
                  justify="center"
                  gap="dimension_08"
                >
                  <Text color="dark" type="paragraphs" size="XS_M_S">
                    {reward.title}
                  </Text>
                  <Text color="dark" type="paragraphs" size="M_XL_S">
                    {reward.amount}
                  </Text>
                </FlexContainer>
              ))}
            </FlexContainer>
            <Text type="paragraphs" color="dark" size="S_M_S" align="center">
              {t('Probabilities.total.win')}
            </Text>
          </>
        )}
      </Styled.TrackingProgress>
    </FlexContainer>
  );
};

export default WinProbabilities;
